<template>
  <boxwrap class="matches--inner">
    <toolbar>
      <!-- <toolbar-items class="-nav">
        <ul class="inner-nav">
          <li class="inner-nav__items">
            <router-link :to="`/scraper/all`">
              <span>all</span>
            </router-link>
          </li>

          <li class="inner-nav__items">
            <router-link :to="`/scraper/deleted`">
              <span>deleted</span>
            </router-link>
          </li>
        </ul>

        <button
          class="btn--tbl-settings"
          @click="showTblSettings = true"
        >
          <i class="ico--tbl-settings"></i>
          <span>table settings</span>
        </button>
      </toolbar-items> -->

      <!-- <toolbar-items
        class="-buttons"
        v-if="checkPermission"
      >

      </toolbar-items> -->

      <toolbar-items class="-searchbar">
        <search
          class="search-bar-wrap"
          :dateBy="dateBy"
          :filterBy="filterBy"
          @refresh="search"
          @clear="search"
          @trigger="trigger"
        >
        </search>
        <button
          class="btn--create"
          title="create"
          @click="scrapeData"
        >
          <i class="ico--create"></i>
        </button>

        <button
          class="btn--delete"
          title="delete"
          v-if="selected.length > 0"
          @click="remove(selected)"
        >
        <!-- v-if="selected.length > 0" -->
          <i class="ico--delete"></i>
        </button>

        <button
          class="btn--restore"
          title="restore"
          v-if="selected.length > 0"
          @click="restore"
        >
          <i class="ico--restore"></i>
        </button>

        <button
          class="btn--modify"
          title="modify"
          v-if="selected.length === 1"
          @click="update()"
        >
          <i class="ico--save"></i>
        </button>

        <button
          class="btn--create"
          title="transfer"
          v-if="selected.length >= 1"
          @click="transferData"
        >
          <span>transfer to matches</span>
        </button>

        <div class="toolbar-rightbtns">
          <button
            class="btn--tbl-settings"
            @click="showTblSettings = true"
          >
            <i class="ico--settings"></i>
          </button>
        </div>
      </toolbar-items>
    </toolbar>

    <boxwrap-contents :class="{'data-loading': showDataLoading}"> <!--  -->
      <check-data-list
        label="loading"
        v-if="isDataLoading || isEmpty"
        :isLoading="isDataLoading"
        :isEmpty="isEmpty"
      >
      </check-data-list>

      <tbl
        :scrollable="true"
        :dataLoading="isDataLoading"
        v-else
      >
        <tbl-inner>
          <tbl-head>
            <tbl-row>
              <tbl-td class="checkbox">
                <checkbox>
                  <input
                    type="checkbox"
                    @change="checkAll(all)"
                  />
                </checkbox>
              </tbl-td>

              <tbl-td
                class="no"
                v-if="checkCol('no', tblSetting)"
                @click.native="sort('no')"
              >
                no
              </tbl-td>

              <tbl-td
                class="game"
                @click.native="sort('game')"
                v-if="checkCol('game', tblSetting)"
              >
                game
              </tbl-td>

              <tbl-td
                class="league"
                v-if="checkCol('league', tblSetting)"
              >
                league
              </tbl-td>

              <tbl-td
                class="schedule"
                v-if="checkCol('schedule', tblSetting)"
              >
                schedule
              </tbl-td>

              <tbl-td
                class="home-team"
                v-if="checkCol('home_team', tblSetting)"
              >
                home team
              </tbl-td>

              <tbl-td
                class="away-team"
                v-if="checkCol('away_team', tblSetting)"
              >
                away team
              </tbl-td>

              <tbl-td
                class="home-score"
                v-if="checkCol('home_score', tblSetting)"
              >
                home score
              </tbl-td>

              <tbl-td
                class="away-score"
                v-if="checkCol('away_score', tblSetting)"
              >
                away score
              </tbl-td>

              <tbl-td
                class="is-active"
                v-if="checkCol('is_active', tblSetting)"
              >
                is active
              </tbl-td>

              <tbl-td
                class="created-at"
                v-if="checkCol('created_at', tblSetting)"
              >
                created at
              </tbl-td>

              <tbl-td
                class="updated-at"
                v-if="checkCol('updated_at', tblSetting)"
              >
                updated at
              </tbl-td>

              <tbl-td
                class="deleted-at"
                v-if="checkCol('deleted_at', tblSetting)"
              >
                deleted at
              </tbl-td>
            </tbl-row>
          </tbl-head>

          <tbl-body>
            <tbl-row
              v-for="match in all"
              :key="match.id"
              @click.native="view(match.id)"
              :class="{'is-deleted': match.deleted_at}"
            >
              <tbl-td class="checkbox" @click.native.stop>
                <checkbox>
                  <input
                    type="checkbox"
                    v-model="selected"
                    :value="match.id"
                  />
                </checkbox>
              </tbl-td>

              <tbl-td
                class="no"
                v-if="checkCol('no', tblSetting)"
                @click.native="sort('no')"
              >
                {{ match.id }}
              </tbl-td>

              <tbl-td
                class="game"
                @click.native="sort('game')"
                v-if="checkCol('game', tblSetting)"
              >
                {{ match.league_meta.game }}
              </tbl-td>

              <tbl-td
                class="league"
                v-if="checkCol('league', tblSetting)"
              >
                {{ match.league_meta.name }}
              </tbl-td>

              <tbl-td
                class="schedule"
                v-if="checkCol('schedule', tblSetting)"
              >
                {{ match.play_date | date }}
              </tbl-td>

              <tbl-td
                class="home-team"
                v-if="checkCol('home_team', tblSetting)"
              >
                {{ match.home_team_meta.name }}
              </tbl-td>

              <tbl-td
                class="away-team"
                v-if="checkCol('away_team', tblSetting)"
              >
                {{ match.away_team_meta.name }}
              </tbl-td>

              <tbl-td
                class="home-score"
                v-if="checkCol('home_score', tblSetting)"
              >
                {{ match.home_score }}
              </tbl-td>

              <tbl-td
                class="away-score"
                v-if="checkCol('away_score', tblSetting)"
              >
                {{ match.away_score }}
              </tbl-td>

              <tbl-td
                class="is-active"
                v-if="checkCol('is_active', tblSetting)"
              >
                {{ match.active }}
              </tbl-td>

              <tbl-td
                class="created-at"
                v-if="checkCol('created_at', tblSetting)"
              >
                {{ match.created_at | date }}
              </tbl-td>

              <tbl-td
                class="updated-at"
                v-if="checkCol('updated_at', tblSetting)"
              >
                {{ match.updated_at | date }}
              </tbl-td>

              <tbl-td
                class="deleted-at"
                v-if="checkCol('deleted_at', tblSetting)"
              >
                {{ match.deleted_at | date }}
              </tbl-td>
            </tbl-row>
          </tbl-body>
        </tbl-inner>

        <tbl-footer>
          <pagination
            :total="count"
            v-model="params.page"
            :rows="params.rows"
            @page="trigger"
          >
          </pagination>
        </tbl-footer>
      </tbl>
    </boxwrap-contents>

    <modal
      class="modal--create"
      title="modify/create game"
      v-if="showCreate"
      :activate="showCreate"
      @activate="showCreate = $event"
    >
      <template slot="body">
        <form
          class="form-con"
          @submit.prevent="save"
        >
          <div class="form-items">
            <div class="form-lbl"><span>game</span></div>
            <div class="form-data">
              <select-list
                :title="game_type_id"
                :withReset="true"
                v-model="game_type_id"
              >
                <select-option
                  v-for="game in games"
                  :value="game.id"
                  :key="game.id"
                  :name="game.name"
                >
                  {{ game.name }}
                </select-option>
              </select-list>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>league</span></div>
            <div class="form-data">
              <select-list
                :title="tempLeague || 'league'"
                :withReset="true"
                v-model="tempLeague"
              >
                <select-option
                  v-for="league in leagues"
                  :key="league.id"
                  :value="league"
                  :name="league.name"
                >
                  {{ league.name }}
                </select-option>
              </select-list>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>schedule</span></div>
            <div class="form-data">
              <date-time-picker
                mode='mode'
                placeholder='schedule'
                @get-mode='editMatch.play_date = $event'
              >
              </date-time-picker>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>home team</span></div>
            <div class="form-data">
              <input-suggestion
                @search="searchTeams"
                v-model="homeTeam"
                placeholder="Home Team"
              >
                <span slot="selected">{{ homeTeam ? homeTeam.name : '' }}</span>
                <suggestion slot="suggestion" :key="team.id" v-for="team in teams" :value="team">
                  {{ team.name }}
                </suggestion>
              </input-suggestion>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>away team</span></div>
            <div class="form-data">
              <input-suggestion
                @search="searchTeams"
                v-model="awayTeam"
                placeholder="Away Team"
              >
                <div slot="selected">{{ awayTeam ? awayTeam.name : '' }}</div>
                <suggestion slot="suggestion" :key="team.id" v-for="team in teams" :value="team">
                  {{ team.name }}
                </suggestion>
              </input-suggestion>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>home score</span></div>
            <div class="form-data">
              <div class="input-wrap">
                <input
                  type="text"
                  placeholder="home score"
                  v-model="editMatch.home_score"
                />
              </div>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>away score</span></div>
            <div class="form-data">
              <div class="input-wrap">
                <input
                  type="text"
                  placeholder="away score"
                  v-model="editMatch.away_score"
                />
              </div>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>is active</span></div>
            <div class="form-data">
              <checkbox>
                <input
                  type="checkbox"
                  v-model="editMatch.active"
                />
              </checkbox>
            </div>
          </div>
        </form>
      </template>

      <template slot="footer">
        <button class="btn--confirm">
          save
        </button>
      </template>
    </modal>

    <table-settings
      :showTblSettings="showTblSettings"
      :allCols="allCols"
      :tblSetting="tblSetting"
      :activate="showTblSettings"
      v-if="modConfig.tableConfig"
      @activate="showTblSettings = $event"
      @load="showLoad()"
    >
    </table-settings>
  </boxwrap>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { checkAll } from '@/assets/js/mixins/base/CheckAll'

//= components
import Checkbox from '@/components/base/Checkbox'
import Pagination from '@/components/base/Pagination'
import Search from '@/components/base/search/Search'
import CheckDataList from '@/components/base/CheckDataList'
import DateTimePicker from '@/components/base/DateTimePicker'
import Modal from '@/components/base/Modal'

import '@/components/base/input/InputSuggestion.js'
import '@/components/base/table/Table'
// import '@/components/layout/boxwrap/Boxwrap'
import '@/components/base/select/Select'
import '@/components/common/table-settings/TableSettings'
import socket from '@/socket'

export default {
  name: 'scraper',

  components: {
    Checkbox,
    Pagination,
    Search,
    CheckDataList,
    DateTimePicker,
    Modal
  },

  mixins: [ checkAll ],

  data () {
    return {
      status: 'all',

      selected: [],
      selectAll: undefined,

      showCreate: false,
      showTblSettings: false,

      isDataLoading: true,
      isEmpty: false,
      showDataLoading: false,

      tblSetting: 'matches_list',

      dateBy: [
        {
          value: 'created_at',
          display: 'created at'
        },
        {
          value: 'updated_at',
          display: 'updated at'
        },
        {
          value: 'deleted_at',
          display: 'deleted at'
        }
      ],

      allCols: [
        {
          value: 'no',
          display: 'no'
        },
        {
          value: 'game',
          display: 'game'
        },
        {
          value: 'league',
          display: 'league'
        },
        {
          value: 'schedule',
          display: 'schedule'
        },
        {
          value: 'home_team',
          display: 'home team'
        },
        {
          value: 'away_team',
          display: 'away team'
        },
        {
          value: 'home_score',
          display: 'home score'
        },
        {
          value: 'away_score',
          display: 'away score'
        },
        {
          value: 'is_active',
          display: 'is active'
        },
        {
          value: 'created_at',
          display: 'created at'
        },
        {
          value: 'updated_at',
          display: 'updated_at'
        },
        {
          value: 'deleted_at',
          display: 'deleted_at'
        }
      ],

      homeTeam: null,
      awayTeam: null,
      tempLeague: '',
      game_type_id: '',
      editMatch: {
        league: undefined,
        away_team: undefined,
        home_team: undefined,
        play_date: '',
        away_score: 0,
        home_score: 0,
        active: false
      },

      filterBy: [
        {
          value: 'id',
          display: 'Id'
        }
      ]
    }
  },

  computed: {
    ...mapGetters('providerMatch', ['all', 'types', 'count']),
    ...mapGetters('game', { games: 'all' }),
    ...mapGetters('league', { leagues: 'all' }),
    ...mapGetters('team', ['teams']),
    checkPermission () {
      let permission = JSON.parse(window.localStorage.permission)
      let dbKey = this.$route.meta.dbKey
      let obj

      for (let key in permission) {
        if (dbKey === key) {
          obj = permission[key]
        }
      }

      return obj === 'rw' ? 1 : ''
    }
  },

  watch: {
    $route ($router) {
      if (!this.showDataLoading) {
        this.showDataLoading = true
      }
      this.search(this.generate($router.query))
    },

    async game_type_id (id) {
      await this.getLeagues({ rows: 100, filter_by: 'game_type_id', q: id })
      await this.getTeams({ rows: 10 })
    },

    teamLeague (league) {
      this.editMatch.league = league.id
      this.editMatch.game_type_id = league.game_type_id
      this.game_type_id = league.game_type_id
    }
  },

  async created () {
    if (this.$route.params.status === undefined) {
      this.$router.push(`${this.$route.path}/all`)
    }

    this.getCount({
      status: this.status,
      params: this.params
    })
    await this.get({
      status: this.status,
      params: this.params
    })
    await this.getGames({ rows: 50 })
    await this.getLeagues({ rows: 100 })

    this.isDataLoading = false
    this.showDataLoading = false
    if (!this.all.length) {
      this.isEmpty = true
    }
  },

  methods: {
    ...mapActions('league', { getLeagues: 'get' }),
    ...mapActions('providerMatch', ['get', 'create', 'update', 'delete', 'deleteBulk', 'getCount', 'transfer', 'scrape']),
    ...mapActions('game', { getGames: 'get' }),
    ...mapActions('team', { getTeams: 'get' }),

    trigger (query) {
      this.params = query || this.params
      this.$router.push({ query: this.params })
    },

    async search (query) {
      this.params = query || this.params
      this.isEmpty = false
      this.status = this.$route.params.status
      this.selected = []

      if (!this.showDataLoading) {
        this.isDataLoading = true
      }

      await this.get({
        params: this.params,
        status: this.status
      })

      await this.getCount({
        params: this.params,
        status: this.status
      })

      this.isDataLoading = false
      this.showDataLoading = false
      if (!this.all.length) {
        this.isEmpty = true
      }
    },

    clear () {
      this.editMatch = {
        league: undefined,
        away_team: undefined,
        home_team: undefined,
        play_date: '',
        away_score: 0,
        home_score: 0,
        active: false
      }
    },

    async save () {
      this.editMatch.home_team = this.homeTeam.id
      this.editMatch.away_team = this.awayTeam.id

      if (this.editMatch.id) {
        await this.upate(this.editMatch)
      } else {
        await this.create(this.editMatch)
      }

      this.clear()
      await this.get({
        status: this.status,
        params: this.params
      })
    },

    async searchTeams (q) {
      let params = { rows: 10 }
      if (q) {
        params.filter_by = 'name'
        params.q = q
      }

      await this.getTeams(params)
    },

    view (id) {
      if (this.checkPermission) {
        this.$router.push(`/scraper/${id}`)
      }
    },

    async remove (ids) {
      await this.deleteBulk(ids)
      this.get({
        status: this.status,
        params: this.params
      })
    },

    async restore () {
      for (let id of this.selected) {
        await this.update({
          id,
          data: {
            deleted_at: null
          }
        })
      }

      this.search()
    },

    async transferData () {
      this.transfer(this.selected)
      socket.scraper.on('message', (data) => {
        if (data.type === 'match-transfer' && data.success) {
          this.search()
        }
      })
    },

    async scrapeData () {
      this.scrape('scrape-matches')
    }
  }
}
</script>
